import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { colors, AuthorizationSchemeService, AuthorizationScheme, ChartjsDirective } from '@mango/core';
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent, ChartjsDirective]
})
export class DashboardComponent implements OnInit {
    myScheme: AuthorizationScheme;

    constructor(private service: DashboardService, private authService: AuthorizationSchemeService) {
        this.myScheme = this.authService.getMyScheme();
    }

    testChart: any;

    ngOnInit(): void {
        this.testChart = this.getChartInfo();
    }


    getChartInfo(): any {
        console.log("getChartInfo called");

        var data = {
            labels: ['Vanilla', 'Chocolate', 'Strawberry', 'Mint Chocolate', 'Cookie Dough', 'Butter Pecan', 'Rocky Road', 'Coffee', 'Other'],
            datasets: [{
                data: [25, 20, 15, 12, 10, 8, 5, 3, 2],
                backgroundColor: [
                    '#FF6384', '#36A2EB', '#FFCE56', '#8bc34a', '#673ab7', '#ff5722', '#9c27b0', '#795548', '#607d8b'
                ]
            }]
        };

        return {
            type: 'pie',
            data: data,
            options: {
                responsive: true,
                display: true,
                legend: {
                    display: true
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var label = data.labels[tooltipItem.index];
                            var value = data.datasets[0].data[tooltipItem.index];
                            return label + ': ' + value + '%';
                        }
                    }
                }
            }
        }
    }
}
